import { useOnboarding } from '@/contexts/OnboardingContext';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles, MapPin } from 'lucide-react';

export function WelcomePrompt() {
  const { showWelcomePrompt, acceptWelcomePrompt, dismissWelcomePrompt } = useOnboarding();

  return (
    <Dialog open={showWelcomePrompt} onOpenChange={(open) => !open && dismissWelcomePrompt()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Sparkles className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-xl">Bem-vindo ao FocusTrack! 🎉</DialogTitle>
          <DialogDescription className="text-base mt-2">
            Que bom ter você aqui! Gostaria de fazer um tour rápido para conhecer todas as funcionalidades da plataforma?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2 mt-4">
          <Button variant="outline" onClick={dismissWelcomePrompt} className="w-full sm:w-auto">
            Pular por agora
          </Button>
          <Button onClick={acceptWelcomePrompt} className="w-full sm:w-auto gap-2">
            <MapPin className="h-4 w-4" />
            Fazer o tour
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
